import axios from 'axios';
import { backendUrl } from 'config/envConfig';

const apiRequestPromise = axios.create({
  baseURL: backendUrl,
})
apiRequestPromise.isCancel = axios.isCancel

export default apiRequestPromise
